import { render, staticRenderFns } from "./CreateCondominiumUser.vue?vue&type=template&id=04588c62&scoped=true&"
import script from "./CreateCondominiumUser.vue?vue&type=script&lang=js&"
export * from "./CreateCondominiumUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateCondominiumUser.vue?vue&type=style&index=0&id=04588c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04588c62",
  null
  
)

export default component.exports